// SMS pricing + segmentation helpers.
//
// Pricing: flat A$0.20 per message part (segment).
// Segmentation: GSM-7 = 160 chars single / 153 per concatenated part;
//               UCS-2 = 70 chars single / 67 per concatenated part.
// We deliberately don't try to bill GSM-7 extension chars as 2 — keep it simple
// and slightly underestimate rather than scaring users.

export const SMS_PRICE_PER_PART = 0.20;
export const GSM_SINGLE_LIMIT = 160;
export const GSM_MULTI_LIMIT = 153;
export const UCS2_SINGLE_LIMIT = 70;
export const UCS2_MULTI_LIMIT = 67;

// Standard GSM 03.38 character set (basic + extension chars).
// eslint-disable-next-line no-misleading-character-class
const GSM_REGEX = /^[A-Za-z0-9 \r\n@£$¥èéùìòÇØøÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ!"#¤%&'()*+,\-./:;<=>?¡ÄÖÑÜ§¿äöñüà^{}\\[~\]|€]*$/;

export function detectSmsEncoding(text) {
  return GSM_REGEX.test(text || "") ? "gsm" : "ucs2";
}

export function smsPartCount(text) {
  const t = text || "";
  if (!t) return 0;
  const enc = detectSmsEncoding(t);
  const len = t.length;
  if (enc === "gsm") {
    return len <= GSM_SINGLE_LIMIT ? 1 : Math.ceil(len / GSM_MULTI_LIMIT);
  }
  return len <= UCS2_SINGLE_LIMIT ? 1 : Math.ceil(len / UCS2_MULTI_LIMIT);
}

export function smsPartLimits(text) {
  const enc = detectSmsEncoding(text);
  if (enc === "gsm") {
    return { single: GSM_SINGLE_LIMIT, multi: GSM_MULTI_LIMIT, encoding: "gsm" };
  }
  return { single: UCS2_SINGLE_LIMIT, multi: UCS2_MULTI_LIMIT, encoding: "ucs2" };
}

export function smsCost(text) {
  return smsPartCount(text) * SMS_PRICE_PER_PART;
}
